import {
  AgeGroup,
  AgeGroupMethod,
} from '@court-sync/shared';
import type { AgeGroupFormData } from '@court-sync/shared';
import { apiGet, apiPost, apiPut, apiDelete, publicApiGet } from './apiClient';

export const ageGroupService = {
  async getPublicAgeGroups(academyId: string): Promise<AgeGroup[]> {
    const response = await publicApiGet<AgeGroup[]>(`/public/age-groups/academy/${academyId}`);
    if (response.success && response.data) {
      return response.data;
    }
    throw new Error(response.error || 'Failed to fetch age groups');
  },

  async getAgeGroups(academyId: string, includeInactive = false): Promise<AgeGroup[]> {
    const response = await apiGet<AgeGroup[]>('/age-groups', {
      params: { academyId, includeInactive },
    });
    if (response.success && response.data) {
      return response.data;
    }
    throw new Error(response.error || 'Failed to fetch age groups');
  },

  async createAgeGroup(academyId: string, data: AgeGroupFormData): Promise<AgeGroup> {
    const response = await apiPost<AgeGroup>('/age-groups', {
      ...data,
      academyId,
    });
    if (response.success && response.data) {
      return response.data;
    }
    throw new Error(response.error || 'Failed to create age group');
  },

  async reorderAgeGroups(academyId: string, orderedIds: string[]): Promise<AgeGroup[]> {
    const response = await apiPut<AgeGroup[]>('/age-groups/reorder', {
      academyId,
      orderedIds,
    });
    if (response.success && response.data) {
      return response.data;
    }
    throw new Error(response.error || 'Failed to reorder age groups');
  },

  async updateAgeGroup(
    id: string,
    academyId: string,
    data: Partial<AgeGroupFormData>
  ): Promise<AgeGroup> {
    const response = await apiPut<AgeGroup>(`/age-groups/${id}`, {
      ...data,
      academyId,
    });
    if (response.success && response.data) {
      return response.data;
    }
    throw new Error(response.error || 'Failed to update age group');
  },

  async deleteAgeGroup(id: string, academyId: string): Promise<void> {
    const response = await apiDelete(`/age-groups/${id}`, {
      params: { academyId },
    });
    if (!response.success) {
      throw new Error(response.error || 'Failed to delete age group');
    }
  },

  async seedAgeGroups(academyId: string, method: AgeGroupMethod): Promise<AgeGroup[]> {
    const response = await apiPost<AgeGroup[]>('/age-groups/seed', {
      academyId,
      method,
    });
    if (response.success && response.data) {
      return response.data;
    }
    throw new Error(response.error || 'Failed to seed age groups');
  },
};
